// Version : 1.0.0
// Author : AGALYA
import AadharDetailsActionType from './aadhar-details.types';

/** ***************** AADHAR FRONT AND BACK IMAGE CHANGED ************************/
export const aadharFrontImageChangedStart = (aadharFront: any) => ({
	type: AadharDetailsActionType.AADHAR_FRONT_IMAGE_CHANGED,
	payload: aadharFront,
});

export const aadharBackImageChangedStart = (aadharBack: any) => ({
	type: AadharDetailsActionType.AADHAR_BACK_IMAGE_CHANGED,
	payload: aadharBack,
});
/** ***************** AADHAR FRONT AND BACK IMAGE CHANGED *********************** */

/** ***************** UPDATE AADHAR START*********************** */
export const updateAadharStart = (aadharCredentials: any) => ({
	type: AadharDetailsActionType.UPDATE_AADHAR_START,
	payload: aadharCredentials,
});

export const updateAadharSuccess = (aadharSuccess: any) => ({
	type: AadharDetailsActionType.UPDATE_AADHAR_SUCCESS,
	payload: aadharSuccess,
});

export const updateAadharFailure = (aadharFailure: unknown) => ({
	type: AadharDetailsActionType.UPDATE_AADHAR_FAILURE,
	payload: aadharFailure,
});

export const updateAadharResponseResetStart = () => ({
	type: AadharDetailsActionType.UPDATE_AADHAR_RESPONSE_REST_START,
});

export const updateAadharResponseChanged = () => ({
	type: AadharDetailsActionType.UPDATE_AADHAR_RESPONSE_CHANGED,
});
/** ***************** UPDATE AADHAR END *********************** */

/** ***************** SEND OTP START *********************** */
export const sendAaharOTPStart = (fetchData: any) => ({
	type: AadharDetailsActionType.SEND_AADHAR_OTP_START,
	payload: fetchData,
});

export const sendAaharOTPSuccess = (successData: any) => ({
	type: AadharDetailsActionType.SEND_AADHAR_OTP_SUCCESS,
	payload: successData,
});

export const sendAaharOTPFailure = (failureData: any) => ({
	type: AadharDetailsActionType.SEND_AADHAR_OTP_FAILURE,
	payload: failureData,
});

export const sendAaharOTPResponseResetStart = () => ({
	type: AadharDetailsActionType.SEND_AADHAR_OTP_RESPONSE_RESET,
});

export const sendAaharOTPResponseChanged = () => ({
	type: AadharDetailsActionType.SEND_AADHAR_OTP_RESPONSE_CHANGED,
});
/** ***************** SEND OTP END *********************** */
